import { observer } from 'mobx-react-lite';
import React from 'react';
import { useMst } from '../../../models/stores/Root';
import ShippingMethodForm from '../../input/ShippingMethodForm';
import DeliverySummary from '../../summary/DeliverySummary';
import { SectionSummaryGroupPosition } from '../../summary/SectionSummary';
import SectionTitle from '../../content/SectionTitle';
import CustomMessage from '../../content/CustomMessage';

export const ShippingMethodSectionTestId = 'ShippingMethodSection-framework';

export type ShippingMethodSectionProps = {
  displaySummary?: boolean;
  groupPosition?: SectionSummaryGroupPosition;
  onShippingMethodEdit?: () => void;
  onValidData?: (shippingMethodId: number) => void;
};

const ShippingMethodSection: React.FC<ShippingMethodSectionProps> = observer(
  ({
    displaySummary,
    groupPosition,
    onShippingMethodEdit,
    onValidData,
  }: ShippingMethodSectionProps) => {
    const rootStore = useMst();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { cart, configuration, currentStep } = rootStore;

    const handleShippingMethodChanged = (shippingMethodId: number): void => {
      cart.updateShippingMethod(shippingMethodId);
      onValidData?.(shippingMethodId);
    };

    return displaySummary && cart.selectedShippingMethod ? (
      <DeliverySummary
        shippingMethod={cart.selectedShippingMethod}
        currencySymbol={configuration.formattedCurrencySymbol}
        onEditDeliveryClicked={onShippingMethodEdit}
        groupPosition={groupPosition}
      />
    ) : (
      <div data-testid={ShippingMethodSectionTestId} className="mt-6">
        <SectionTitle>Shipping Method</SectionTitle>
        {!!configuration.messages.delivery && (
          <CustomMessage customMessage={configuration.messages.delivery} />
        )}
        <ShippingMethodForm
          selectedShippingMethod={cart.selectedShippingMethod}
          isLoading={cart.fetchingShippingMethods}
          isRefetching={rootStore.stateMatches(
            'Guest.Shipping.Methods.NotFetched'
          )}
          formattedCurrencySymbol={configuration.formattedCurrencySymbol}
          shippingMethods={cart.cartData.shippingMethods}
          onShippingMethodChanged={handleShippingMethodChanged}
        />
      </div>
    );
  }
);

export default ShippingMethodSection;
